export interface LogContext {
  [key: string]: any;
}

export enum LogSeverity {
  Error,
  Warning,
  Info,
  Debug,
}

function log() {
  return function (
    message: string,
    severity: LogSeverity = LogSeverity.Info,
    context: LogContext = {}
  ): void {
    /*
    if (severity > LogSeverity.Warning) {
      return;
    }
    */
    const prefix: string[] = [];

    let packageString = "linkly-pos";

    switch (severity) {
      case LogSeverity.Debug:
        packageString = `${packageString}/DEBUG`;
        break;
      case LogSeverity.Info:
        packageString = `${packageString}/INFO`;
        break;
      case LogSeverity.Warning:
        packageString = `${packageString}/WARNING`;
        break;
      case LogSeverity.Error:
        packageString = `${packageString}/ERROR`;
        break;
    }

    prefix.push(packageString);

    const contextParts: string[] = [];

    Object.entries(context).forEach(([key, value]) => {
      contextParts.push(`${key}: ${value}`);
    });

    let suffix = "";
    if (contextParts.length > 0) {
      suffix = ` | {${contextParts.join(", ")}}`;
    }
    console.log(severity, `[${prefix.join("] [")}] ${message}${suffix}`);
  };
}

const logger = log();
export default logger;
